export default __webpack_public_path__ + "static/media/music.daaf2467.png";